import type * as React from "react";
import ConfirmationModal from "./ConfirmationModal";
import { useTranslation } from "react-i18next";
import classnames from "classnames";
import { useIsMinTabletSize } from "../hooks/useMediaQuery";
import { IMG_EMPTY_CART } from "~/utils/url/staticResources";
import CenterContents from "./CenterContents";
import { styled } from "@mui/material/styles";
import { FontSize, getFontStyle } from "~/common/components/materialInput/Fonts";
import { Icon } from "./icon/Icon";
import { IconSize } from "./icon/IconSize";
import { IconType } from "./icon/IconType";

export const ModalTitle = styled("h1")({
  ...getFontStyle(FontSize.HeadlineSmall),
  paddingTop: "24px",
  paddingBottom: "16px",
});

interface Props {
  onOk?: () => void;
  onCancel: () => void;
  messageKey?: string;
}

const DeleteCartConfirmationModal: React.FC<Props> = ({ messageKey = "deleteConfirmation.cart", ...props }) => {
  const { t } = useTranslation();

  const ok = t("deleteConfirmation.button");
  const cancel = t("contactUsPage.form.cancel");

  const isTablet = useIsMinTabletSize();

  return (
    <ConfirmationModal
      okLabel={ok}
      cancelLabel={cancel}
      startIcon={<Icon size={IconSize.FONT_24} type={IconType.Bin} color="red" />}
      {...props}
    >
      {isTablet ? (
        <h3 className="title-large">{t(messageKey)}</h3>
      ) : (
        <CenterContents className={"d-flex flex-direction-column f-center"}>
          <h1 className="headline-small">{t(messageKey)}</h1>
          <img className="mt-4" src={IMG_EMPTY_CART} />
        </CenterContents>
      )}
    </ConfirmationModal>
  );
};

export default DeleteCartConfirmationModal;
